import { Wordmark } from "@/components/Wordmark";

const LINKS = [
  { label: "Capabilities", href: "#capabilities" },
  { label: "Systems", href: "#products" },
  { label: "Sovereign", href: "#sovereign" },
  { label: "Contact", href: "#contact" },
];

export function Footer() {
  return (
    <footer className="relative border-t border-ink-800/80 px-5 py-12 sm:px-8">
      <div className="mx-auto flex max-w-7xl flex-col gap-8">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-start sm:justify-between">
          <div className="flex flex-col gap-3">
            <Wordmark />
            <p className="max-w-xs text-sm text-ink-500">
              Forward deployed engineering — software, silicon, and autonomous systems, owned
              end to end.
            </p>
          </div>

          <nav className="flex flex-wrap gap-x-8 gap-y-2">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="font-mono text-[0.72rem] uppercase tracking-[0.16em] text-ink-400 transition-colors hover:text-ink-50"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="flex flex-col gap-3 border-t border-ink-800/60 pt-6 font-mono text-[0.62rem] uppercase tracking-[0.14em] text-ink-600 sm:flex-row sm:items-center sm:justify-between">
          <span>fwd-deployed.ai · forward-deployed.dev</span>
          <span>// Unclassified · Portfolio</span>
          <span>© {new Date().getFullYear()} Chase Bradley-West</span>
        </div>
      </div>
    </footer>
  );
}
